import * as dateFns from "date-fns";

export default defineNuxtPlugin((nuxtApp) => {
  const app = nuxtApp.vueApp;
  app.config.globalProperties.$dateFns = dateFns;
  app.provide("dateFns", dateFns);
});
